import { Component, OnInit } from '@angular/core';
import { addDays, format, parseISO } from 'date-fns';
import { Subscription, interval } from 'rxjs';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog } from '@angular/material/dialog';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';

@Component({
    selector: 'app-kpi-sotif',
    templateUrl: './kpi-sotif.component.html',
    styleUrls: ['./kpi-sotif.component.css'],
    standalone: false
})
export class KPISotifComponent implements OnInit {

  subscription: Subscription | undefined;
  items: any[] = [];
  itemsFiltrados: any[] = [];
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  urlSalva: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  // urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  urlConsultaCompactada: string = 'https://ymm2qay9pj.execute-api.sa-east-1.amazonaws.com/V1';
  urlConsultaCompleta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  queryControlCenter: string = 'controlCenterDB';
  query: string = 'Itens_Jetta';
  queryFreteExtra: string = 'extraFreight';
  queryBriefing: string = 'Briefing';
  queryContainer: string = 'items_Excel_Container';
  query2: string = 'Carriers';
  query3: string = 'tipos_Veiculos_Karrara';
  queryVeiculosLab: string = 'veiculos_lab_Karrara';
  query4: string = 'items_Excel_Karrara';
  queryInterplantas: string = 'Operacao_Interplantas_Karrara';
  queryInterplantasAmb: string = 'relatorioPreenchidoInterplantas';
  data: any;
  DataAtual: Date = new Date();
  dialogOpen!: boolean;
  dialogAddViagem!: boolean;
  janela1!: string;
  janela2!: string;
  janela3!: string;
  janela4!: string;
  editJanela1!: string;
  editJanela2!: string;
  editJanela3!: string;
  editJanela4!: string;
  janelaDestino1!: string;
  janelaDestino2!: string;
  janelaDestino3!: string;
  janelaDestino4!: string;
  editJanelaDestino1!: string;
  editJanelaDestino2!: string;
  editJanelaDestino3!: string;
  editJanelaDestino4!: string;
  carriers!: any[];
  transportadora!: string[];
  fornecedores1!: any[];
  fornecedores2!: any[];
  fornecedores3!: any[];
  fornecedores4!: any[];
  fornecedoresDescarga1!: any[];
  fornecedoresDescarga2!: any[];
  fornecedoresDescarga3!: any[];
  fornecedoresDescarga4!: any[];
  isLoading: boolean = true;
  itemsControlCenter!: any[];
  usuarioLogado: any;
  isAdminEnabled: boolean = false;
  isUserEnabled: boolean = false;
  isCarrierEnabled: boolean = false;
  interplantas: { intRealizadas: number, intMu: number, intCanceladas: number, intCritico: number, intObs: string } = {
    intRealizadas: 0,
    intMu: 0,
    intCanceladas: 0,
    intCritico: 0,
    intObs: ''
  };
  importacao: { impViagens: number, impMu: number, impLcb: number, impSla: number, impLc: number, impMuARG: number, impArg: number, impObs: string } = {
    impViagens: 0,
    impMu: 0,
    impLcb: 0,
    impSla: 0,
    impLc: 0,
    impMuARG: 0,
    impArg: 0,
    impObs: ''
  };
  exportacao: { expViagens: number, expMu: number, expLcb: number, expKd: number, expNavistar: number, expChina: number, expObs: string } = {
    expViagens: 0,
    expMu: 0,
    expLcb: 0,
    expKd: 0,
    expNavistar: 0,
    expChina: 0,
    expObs: ''
  };
  reutilizacao: { reutRealizadas: number, reutCanceladas: number, reutCritico: string, reutObs: string } = {
    reutRealizadas: 0,
    reutCanceladas: 0,
    reutCritico: '',
    reutObs: ''
  };
  eCarrier: { eCarData: string, eCarEcarrier: number, eCarResponsavel: string, eCarTransportadora: string, eCarObs: string } = {
    eCarData: "",
    eCarEcarrier: 0,
    eCarResponsavel: '',
    eCarTransportadora: '',
    eCarObs: ''
  };
  freteExtra: { fexPlanejadas: number, fexRealizadas: number, fexRmc: number, fexLomlt: number, fexObs: string } = {
    fexPlanejadas: 0,
    fexRealizadas: 0,
    fexRmc: 0,
    fexLomlt: 0,
    fexObs: ''
  };
  mrjsl: { jslRealizadas: number, jslmu: number, jslSul: number, jslSp: number, jslObs: string, jslMuTotal: number } = {
    jslRealizadas: 0,
    jslmu: 0,
    jslSul: 0,
    jslSp: 0,
    jslMuTotal: 0,
    jslObs: ''
  };
  mrtcm: { tcmRealizadas: number, tcmMu: number, tcmColetas: number, tcmCarros: number, tcmEntregas: number, tcmObs: string } = {
    tcmRealizadas: 0,
    tcmMu: 0,
    tcmColetas: 0,
    tcmCarros: 0,
    tcmEntregas: 0,
    tcmObs: ''
  };
  desvios: { desvLocal: string, desvTransportadora: number, desvCritico: string, desvObs: string, desvScania: number, desvLCB: number, desvForn: number } = {
    desvLocal: '',
    desvTransportadora: 0,
    desvCritico: '',
    desvObs: '',
    desvForn: 0,
    desvLCB:0,
    desvScania: 0
  };
  sotif: { sotPrec: number, sotTransporte: number } = {
    sotPrec: 0,
    sotTransporte: 0,
  };
  volRecebimento: {
    qtVeiculosFE: number;
    qtVeiculosAereo: number;
    qtVeiculosCrageaLots: number;
    qtVeiculosSantosLots: number;
    qtVeiculosCrageaSuzan: number;
    qtVeiculosSantosSuzan: number;
    qtVeiculosCrageaGlovis: number;
    qtVeiculosSantosGlovis: number;
    qtVeiculosMRjsl: number;
    qtVeiculosDiretos: number;
    qtVeiculosMRtcm: number;
    qtVeiculosARGjsl: number;
    qtPalletsFE: number;
    qtPalletsAereo: number;
    qtPalletsCrageaLots: number;
    qtPalletsSantosLots: number;
    qtPalletsCrageaSuzan: number;
    qtPalletsSantosSuzan: number;
    qtPalletsCrageaGlovis: number;
    qtPalletsSantosGlovis: number;
    qtPalletsMRjsl: number;
    qtPalletsDiretos: number;
    qtPalletsMRtcm: number;
    qtPalletsARGjsl: number;
    qtMediaFE: number;
    qtMediaAereo: number;
    qtMediaCrageaLots: number;
    qtMediaSantosLots: number;
    qtMediaCrageaSuzan: number;
    qtMediaSantosSuzan: number;
    qtMediaCrageaGlovis: number;
    qtMediaSantosGlovis: number;
    qtMediaMRjsl: number;
    qtMediaDiretos: number;
    qtMediaMRtcm: number;
    qtMediaARGjsl: number;
    veicTotal: number;
    palletsTotal: number;
    mediaTotal: number;
  } = {
      qtVeiculosFE: 0,
      qtVeiculosAereo: 0,
      qtVeiculosCrageaLots: 0,
      qtVeiculosSantosLots: 0,
      qtVeiculosCrageaSuzan: 0,
      qtVeiculosSantosSuzan: 0,
      qtVeiculosCrageaGlovis: 0,
      qtVeiculosSantosGlovis: 0,
      qtVeiculosMRjsl: 0,
      qtVeiculosDiretos: 0,
      qtVeiculosMRtcm: 0,
      qtVeiculosARGjsl: 0,
      qtPalletsFE: 0,
      qtPalletsAereo: 0,
      qtPalletsCrageaLots: 0,
      qtPalletsSantosLots: 0,
      qtPalletsCrageaSuzan: 0,
      qtPalletsSantosSuzan: 0,
      qtPalletsCrageaGlovis: 0,
      qtPalletsSantosGlovis: 0,
      qtPalletsMRjsl: 0,
      qtPalletsDiretos: 0,
      qtPalletsMRtcm: 0,
      qtPalletsARGjsl: 0,
      qtMediaFE: 0,
      qtMediaAereo: 0,
      qtMediaCrageaLots: 0,
      qtMediaSantosLots: 0,
      qtMediaCrageaSuzan: 0,
      qtMediaSantosSuzan: 0,
      qtMediaCrageaGlovis: 0,
      qtMediaSantosGlovis: 0,
      qtMediaMRjsl: 0,
      qtMediaDiretos: 0,
      qtMediaMRtcm: 0,
      qtMediaARGjsl: 0,
      veicTotal: 0,
      palletsTotal: 0,
      mediaTotal: 0
    };
  item: any;
  infoBirefing!: any[];
  container: any;
  milkRunArg: any;
  embalagens: any;
  milkRunSP: any;
  milkRunSul: any;
  interplantasArray!: any[];
  interplantasAmbArray!: any[];
  itemsContainers!: any[];
  argentina!: any[];
  embalagensArray!: any[];
  veiculos: any;
  filterColumn: string = 'date';
  referenceDate!: string;
  numDays: number = 1;
  veiculosLAB!: any[];
  dataFiltro: string = '';
  dataLoaded: boolean = false;
  itemsMR!: any[];
  itemsFreteExtra!: any[];
  dataMostra: string = "";

  constructor(
    private dynamoDBService: ApiService,
    public dialog: MatDialog,
    private autenticacaoService: AutenticacaoService
  ) { }

  async ngOnInit() {
    await this.getUserLogado();
    await this.getVeiculosFromDynamoDB();
    await this.getVeiculosLAB();
    await this.dataFilter();
    await this.update();
    this.dataLoaded = true;
    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      await this.update();
      this.isLoading = false;
    });
  }

  async update() {
    await this.getItemsMRFromDynamoDB();
    await this.getFreteExtraFromDynamoDB();
    await this.getBriefingFromDynamoDB();
    await this.getItemsFromArgentina();
    await this.getItemsContainer();
    await this.getItemsFromInterplantas();
    await this.getItemsFromInterplantasAMB();
    await this.enableFields();
    await this.somarImpMU();
    await this.consolidarNumeros()
    this.isLoading = false;
  }

  async getUserLogado() {
    //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.autenticacaoService.obterUsuarioLogado()
    //console.log(this.usuarioLogado)
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isAdminEnabled = true;
    // } else if (this.usuarioLogado.role == '1') {
    } else if (this.usuarioLogado.role == '1' || this.usuarioLogado.role == '6' || this.usuarioLogado.role == '5' || this.usuarioLogado.role == '7' || this.usuarioLogado.role == '8') {
      this.isUserEnabled = true;
    } else if (this.usuarioLogado.role == '3') {
      this.isCarrierEnabled = true;
    }
    // console.log( this.usuarioLogado.role)
    // console.log( this.isAdminEnabled)
  }

  // async dataFilter() {
  //   console.log(this.dataFiltro)
  //   console.log(typeof this.dataFiltro)
  //   await this.update();
  // }

  async dataFilter() {
    if (this.dataFiltro != "") {
      this.isLoading = true;
      // console.log(typeof this.dataFiltro);
      // console.log(this.dataFiltro);
      this.dataMostra = this.dataFiltro;
      this.dataFiltro = this.formatDate(this.dataFiltro);
      this.referenceDate = this.dataFiltro;
      // console.log(this.referenceDate);
      await this.update();
    }
    else {
      const today = new Date(); // Data atual
      const yesterday = new Date(today); // Clone da data atual
      yesterday.setDate(today.getDate() - 1); // Subtrai um dia da data atual
      const yesterdayInMilliseconds = yesterday.getTime();
      // console.log(this.convertTimestampToFormattedDate(yesterdayInMilliseconds));
      this.referenceDate = this.convertTimestampToFormattedDate(yesterdayInMilliseconds);
      // console.log(this.referenceDate);
      this.dataMostra = format(yesterdayInMilliseconds, "yyyy-MM-dd");
    }
  }

  somarImpMU() {
    this.importacao.impMu = this.importacao.impMu + this.importacao.impMuARG;
    this.importacao.impViagens = this.importacao.impSla + this.importacao.impArg + this.importacao.impLc + this.importacao.impLcb;
  }

  formatDate(dateString: string): string {
    // Usando parseISO para criar uma data a partir de uma string ISO
    const parsedDate = parseISO(dateString);
    // Usando format para formatar a data para o formato "dd/MM/yyyy HH:mm"
    const futureDate = addDays(parsedDate, 1);
    // const pastDate = addDays(parsedDate, -1);
    // this.dataMostra = format(pastDate, "dd/MM/yyyy");
    // Usando format para formatar a data para o formato "dd/MM/yyyy HH:mm"
    return format(futureDate, "dd/MM/yyyy HH:mm");
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    const timestampSeconds = timestamp / 1000;
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    date.setHours(23, 59, 0, 0); // horas, minutos, segundos, milissegundos
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  compararDatas(data1: string, data2: string) {
    const dataFormatada1 = new Date(data1).toLocaleDateString();
    const dataFormatada2 = new Date(data2).toLocaleDateString();
    return dataFormatada1 === dataFormatada2;
  }

  isValorValido(value: any): boolean {
    return value != '' && value != null && value != undefined && value != 0;
  }

  async deleteItem(ID: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      await this.dynamoDBService.deleteItem(ID, this.urlSalva, this.query).subscribe(
        async response => {
          // setTimeout(() => {
          await this.ngOnInit();
          this.isLoading = false;
          // }, 400); // Ajuste o tempo de atraso conforme necessário
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }

  selecionarTexto(event: FocusEvent): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.select(); // Seleciona o valor atual do input
  }

  calcularMedia(mediaKey: string, pallets: number, veiculos: number){
    // console.log(pallets)
    // console.log(veiculos)
    if (veiculos === 0) {
      (this.volRecebimento as any)[mediaKey] = 0;
    } else {
      (this.volRecebimento as any)[mediaKey] = pallets / veiculos;
    }
  }

  async salvar(item: any) {
    // console.log(item)
    // this.isLoading = true;
    const currentDate = new Date();
    const formattedDate = format(currentDate, 'yyyy-MM-dd');
    this.item = { ...item };
    if (!this.item.ID || this.item.ID === undefined) {
      // const currentDate = new Date();
      // const formattedDate = format(currentDate, 'ddMMyyyy');
      //console.log(formattedDate);
      this.item.ID = formattedDate.toString();
    }
    // ver se esta vazio e comparar com janela 1
    // console.log(item)
    this.item.date = formattedDate;
    // this.item.tela = tela;
    this.item.tableName = this.queryBriefing
    this.item.userLogado = this.usuarioLogado.id
    const itemsDataString = JSON.stringify(this.item);
    const modifiedString = itemsDataString.replace(/\\"/g, '"');
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    const modifiedJsonString = JSON.stringify(jsonObject);
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray);
    // await this.dynamoDBService.salvar(jsonArray, "", this.urlSalva).subscribe(async response => {
    //   await this.update();
    //   this.isLoading = false;
    // }, error => {
    //   console.log(error);
    // });
  }

  isISODateValid(dateString: string) {
    // Tenta criar um objeto Date a partir da string
    const date = new Date(dateString);
    // Verifica se o objeto Date é um objeto de data válido e não é NaN
    return !isNaN(date.getTime());
  }

  async getBriefingFromDynamoDB(): Promise<void> {
    //console.log("entrou em getFornecedoresFromDynamoDB")
    const currentDate = new Date();
    const formattedDate = format(currentDate, 'yyyy-MM-dd');
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsVolumesAltos(this.queryBriefing, this.urlConsultaCompactada, 'All', 'data', this.referenceDate, 1)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.infoBirefing = items;
          } else {
            console.error('Invalid items data:', items);
          }
          // console.log(this.infoBirefing);
          const itemsInterplantas = this.infoBirefing.filter((item: { tela: string; data: string; }) => item.tela == 'interplantas' && item.data == formattedDate)
          const itemsImportacao = this.infoBirefing.filter((item: { tela: string; data: string; }) => item.tela == 'importacao' && item.data == formattedDate)
          const itemsExportacao = this.infoBirefing.filter((item: { tela: string; data: string; }) => item.tela == 'exportacao' && item.data == formattedDate)
          const itemsReutilizacao = this.infoBirefing.filter((item: { tela: string; data: string; }) => item.tela == 'reutilizacao' && item.data == formattedDate)
          const itemsECarrier = this.infoBirefing.filter((item: { tela: string; data: string; }) => item.tela == 'eCarrier' && item.data == formattedDate)
          const itemsFreteExtra = this.infoBirefing.filter((item: { tela: string; data: string; }) => item.tela == 'freteExtra' && item.data == formattedDate)
          const itemsMrJsl = this.infoBirefing.filter((item: { tela: string; data: string; }) => item.tela == 'mrjsl' && item.data == formattedDate)
          const itemsMrTcm = this.infoBirefing.filter((item: { tela: string; data: string; }) => item.tela == 'mrtcm' && item.data == formattedDate)
          const itemsDesvios = this.infoBirefing.filter((item: { tela: string; data: string; }) => item.tela == 'desvios' && item.data == formattedDate)
          const itemsSotif = this.infoBirefing.filter((item: { tela: string; data: string; }) => item.tela == 'sotif' && item.data == formattedDate)
          // console.log(itemsInterplantas);
          if (itemsInterplantas.length > 0) {
            this.interplantas = { ...this.interplantas, ...itemsInterplantas[0] };
            // // Pega o primeiro objeto do array de resposta
            // const data = itemsInterplantas[0];          
            // // Atribui os valores do objeto recebido ao objeto `interplantas`
            // this.interplantas.intRealizadas = data.intRealizadas;
            // this.interplantas.intMu = data.intMu;
            // this.interplantas.intCanceladas = data.intCanceladas;
            // this.interplantas.intCritico = data.intCritico;
            // this.interplantas.intObs = data.intObs;
          }
          if (itemsImportacao.length > 0) {
            this.importacao = { ...this.importacao, ...itemsImportacao[0] };
          }
          if (itemsExportacao.length > 0) {
            this.exportacao = { ...this.exportacao, ...itemsExportacao[0] };
          }
          if (itemsReutilizacao.length > 0) {
            this.reutilizacao = { ...this.reutilizacao, ...itemsReutilizacao[0] };
          }
          if (itemsECarrier.length > 0) {
            this.eCarrier = { ...this.eCarrier, ...itemsECarrier[0] };
          }
          if (itemsFreteExtra.length > 0) {
            this.freteExtra = { ...this.freteExtra, ...itemsFreteExtra[0] };
          }
          if (itemsMrJsl.length > 0) {
            this.mrjsl = { ...this.mrjsl, ...itemsMrJsl[0] };
          }
          if (itemsMrTcm.length > 0) {
            this.mrtcm = { ...this.mrtcm, ...itemsMrTcm[0] };
          }
          if (itemsDesvios.length > 0) {
            this.desvios = { ...this.desvios, ...itemsDesvios[0] };
          }
          if (itemsSotif.length > 0) {
            this.sotif = { ...this.sotif, ...itemsSotif[0] };
          }
          // console.log(this.interplantas);
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getFreteExtraFromDynamoDB(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsVolumesAltos(this.queryFreteExtra, this.urlConsultaCompactada, 'All', 'dateDelivery', this.referenceDate, 1)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.itemsFreteExtra = items;
            // console.log(this.itemsFreteExtra);
            this.freteExtra.fexPlanejadas = this.itemsFreteExtra.length;
            this.freteExtra.fexRealizadas = this.itemsFreteExtra.filter(item => item.status == 'Canceled' || item.status == 'Completed').length;
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
      // },
      // (error: any) => {
      //   console.error(error);
      // }
    } catch (error) {
      console.error('Error parsing JSON:', error);
    }
    // );
  }


  async getItemsContainer(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsVolumesAltos(this.queryContainer, this.urlConsultaCompactada, 'All', "Janela", this.referenceDate, 1)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          ////console.log(items)
          if (Array.isArray(items)) {
            this.itemsContainers = items;
            this.itemsContainers.forEach(container => {
              if (!container['Total Distance'] && (container.distanceTrecho1 || container.distanceTrecho2)) {
                container['Total Distance'] = container.distanceTrecho1 + container.distanceTrecho2;
                container['emissaoTotal'] = container.emissaoTrecho1 + container.emissaoTrecho2;
              }
              this.importacao.impMu += parseInt(container.Volumes);
            });
            this.importacao.impLc = this.itemsContainers.filter(item => item.destino == 'LC PNEUS').length;
            this.importacao.impLcb = this.itemsContainers.filter(item => item.destino == 'LCB').length;
            this.importacao.impSla = this.itemsContainers.filter(item => item.destino == 'SCANIA').length;
            this.reutilizacao.reutRealizadas = this.itemsContainers.filter(item => item.destinoApos.includes('REUTILIZAR')).length;

            // this.itemsContainers.forEach(item => {
            //   console.log(item.destino)
            //   console.log(item.Janela)
            // })
            // console.log(this.itemsContainers.filter(item => item.destino == 'LC PNEUS'))
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getItemsFromInterplantasAMB(): Promise<void> {
    try {
      // console.log(this.referenceDate)
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsVolumesAltos(this.queryInterplantasAmb, this.urlConsultaCompactada, 'All', 'plannedArrival', this.referenceDate, 1)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.interplantasAmbArray = items;
            await this.interplantasAmbArray.forEach(item => {
              item['Transport Type'] = item['Transport Type'] ? item['Transport Type'] : item.vehicle
              item['Fornecedor 1'] = item['Fornecedor 1'] ? item['Fornecedor 1'] : item.fornecedor
              item['Weight Loaded'] = item['Weight Loaded'] ? item['Weight Loaded'] : item.weight
              item.Volumes = 0
              item.Cubage = 0
              item.Plate = item.Plate ? item.Plate : item.plate
              item['Total Distance'] = item['Total Distance'] ? item['Total Distance'] : item.distance
              item['Total Cost'] = item['Total Cost'] ? item['Total Cost'] : item.valorFrete
              item.veiculoPerfil = item.veiculoPerfil ? item.veiculoPerfil : this.veiculos.find((veiculo: { modelo: any; }) => veiculo.modelo == item['Transport Type']) ? this.veiculos.find((veiculo: { modelo: any; }) => veiculo.modelo == item['Transport Type']).perfil : 'Pequeno'
            })
            this.interplantas.intCritico = this.interplantasAmbArray.length;
            // console.log("ambulancia")
            // console.log(this.interplantasAmbArray)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getItemsFromInterplantas(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsVolumesAltos(this.queryInterplantas, this.urlConsultaCompactada, 'All', 'Janela', this.referenceDate, 1)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          ////console.log(items)
          if (Array.isArray(items)) {
            this.interplantasArray = items;
            // this.interplantasArray = items.filter(item => this.shouldIncludeInterplantas(item))
            // //console.log(this.interplantasArray)
            await this.interplantasArray.forEach(item => {
              item.date = item.date ? item.date : item.Janela
              item['Transport Type'] = item['Transport Type'] ? item['Transport Type'] : item.modelo && item.modelo != '' ? item.modelo : undefined
              item['Fornecedor 1'] = item['Fornecedor 1'] ? item['Fornecedor 1'] : 'LCB'
              item['Weight Loaded'] = item['Weight Loaded'] ? item['Weight Loaded'] : (item.Transportadora == 'LOTS' ? 25000 : 8800)
              item.Volumes = item.Volumes ? item.Volumes : 0
              item.Cubage = item.Cubage ? item.Cubage : 0
              item['Total Distance'] = item['Total Distance'] ? item['Total Distance'] : 16.6
              item['Total Cost'] = item['Total Cost'] ? item['Total Cost'] : 0
              item.veiculoPerfil = item.veiculoPerfil ? item.veiculoPerfil : this.veiculos.find((veiculo: { modelo: any; }) => veiculo.modelo == item['Transport Type']) ? this.veiculos.find((veiculo: { modelo: any; }) => veiculo.modelo == item['Transport Type']).perfil : 'Grande'
            })
            // this.interplantasArray.forEach(item => console.log(item.Janela))            
            this.interplantas.intRealizadas = this.interplantasArray
              .filter(item => item.PassoEntrega > 0).length
            this.interplantas.intCanceladas = this.interplantasArray
              .filter(item => item.viagemCancelada == true).length
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getItemsFromArgentina(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsVolumesAltos(this.query4, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, 10)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.argentina = items;
            this.argentina = this.argentina
              .filter(item => this.shouldIncludeArgentina(item))
              .map(item => ({ ...item, checked: false }));
            this.argentina.forEach(item => {
              // console.log(typeof item['Weight Loaded'])
              // console.log(item['Weight Loaded'])
              item['Weight Loaded'] = item['Weight Loaded'] ? this.removeCommaAndConvertToNumber(item['Weight Loaded']) : "";
              this.importacao.impMuARG += parseInt(item.Volumes);
            });
            this.importacao.impArg = this.argentina.length;
            this.embalagensArray = items
              .filter(item => this.shouldIncludeEmabalagens(item))
            // //console.log(this.embalagensArray)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getItemsMRFromDynamoDB(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsVolumesAltos(this.query, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, 1)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          ////console.log(items)
          if (Array.isArray(items)) {
            this.itemsMR = items
            const viagensJSL = this.itemsMR.filter(item => item.description.toLowerCase().includes('jsl'));
            this.mrjsl.jslRealizadas = viagensJSL.length;
            // console.log(viagensJSL)
            viagensJSL.forEach(item => {
              if (item.Volumes) { this.mrjsl.jslmu += parseInt(item.Volumes) }
            });
            const viagensTCM = this.itemsMR.filter(item => item.description.toLowerCase().includes('tcm'));
            this.mrtcm.tcmRealizadas = viagensTCM.length;
            viagensTCM.forEach(item => {
              if (item.Volumes) { this.mrtcm.tcmMu += parseInt(item.Volumes) }
            });
            const viagensJSLSP = viagensJSL.filter(item => item.description.toLowerCase().includes('sp'));
            const viagensJSLSul = viagensJSL.filter(item => item.description.toLowerCase().includes('sul'));
            this.mrjsl.jslSp = viagensJSLSP.length;
            this.mrjsl.jslSul = viagensJSLSul.length;
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getVeiculosLAB(): Promise<void> {
    try {
      const filtro = '';
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.queryVeiculosLab, this.urlConsultaCompleta, filtro)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculosLAB = items;
            // console.log(this.veiculosLAB)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getVeiculosFromDynamoDB(): Promise<void> {
    try {
      const filtro = '';
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query3, this.urlConsultaCompleta, filtro)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculos = items;
            // console.log(this.veiculos)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  // shouldIncludeItemContainer(item: any): boolean {
  //   console.log(this.container)
  //   if (this.container) {
  //     return true;
  //   }
  //   return false;
  // }

  shouldIncludeArgentina(item: any): boolean {
    const description = item.description ? item.description : '';
    if (this.argentina && (description.includes('arg') || description.includes('ARG')) && (!description.includes('EMBALAGEM') || !description.includes('embalagem'))) {
      return true;
    }
    return false;
  }

  shouldIncludeInterplantas(item: any): boolean {
    const description = item.description ? item.description : '';
    if (this.interplantas) {
      return true;
    }
    return false;
  }

  shouldIncludeEmabalagens(item: any): boolean {
    const description = item.description ? item.description : '';
    if (this.argentina && (description.includes('embalagem') || description.includes('EMBALAGEM'))) {
      return true;
    }
    return false;
  }

  shouldIncludeItem(item: any): boolean {
    const description = item.description ? item.description : '';
    if (this.milkRunSP && (description.includes('JSL') || description.includes('jsl'))) {
      ////console.log(description)
      return true;
    }
    if (this.milkRunSul && (description.includes('tcm') || description.includes('TCM'))) {
      return true;
    }
    return false;
  }

  removeCommaAndConvertToNumber(numberString: string): number {
    // Remove the comma
    const cleanedString = numberString.toString().replace(/,/g, '');
    return parseFloat(cleanedString);
  }

  async consolidarNumeros(){
    // console.log('entrou no calculo')
    // console.log(this.itemsMR)
    this.desvios.desvLCB = 0;
    this.desvios.desvScania = 0;
    this.desvios.desvForn = 0;
    this.desvios.desvTransportadora = 0;
    this.itemsMR.forEach(item => {
      if(item.desvio && item.responsavelDesvio == "LCB"){
        this.desvios.desvLCB += 1;
        // console.log( this.desvios.desvLCB)
      }
      else if(item.desvio && item.responsavelDesvio == "SCANIA"){
        this.desvios.desvScania += 1;
        // console.log(this.desvios.desvScania)
      }
      else if(item.desvio && item.responsavelDesvio == "Fornecedor"){
        this.desvios.desvForn += 1;
        // console.log(this.desvios.desvForn)
      }
      else if(item.desvio && item.responsavelDesvio == "Transportadora"){
        this.desvios.desvTransportadora += 1;
        // console.log( this.desvios.desvTransportadora)
      }
      else{
        // console.log('sem desvios')
      }
    })
  }



  cancel(): void {
    this.dialogOpen = false;
    this.dialogAddViagem = false;
  }

}









